
<template>
  <div>
    <div class="title-text">{{title}}</div>
    <div>{{text}}</div>
  </div>
</template>

<script>
export default {
  name: 'input-box',
  props: {
    text: { type: String },
    title: { type: String }
  }
}
</script>

<style lang="scss" scoped>
@import './../../unified.scss';
.title-text {
  font-weight: bold;
  margin:0.5rem 0rem 0rem 0rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Atoms/TitleAndText.vue